import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Button} from '../button';
import {Icon} from '../icon';
import {getRestProps} from '../utils';
import {makeNotificationStyles} from './styles';
import {theme} from '../../styles/theme';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {type, title, content, children, closable, icon, classNamePrefix, position, className} = this.get();
    const { k } = this.config;
    
    const classNameObj = {
        [`${k}-notification`]: true,
        [className]: className,
        [`${k}-${type}`]: type && (type === 'info' || type === 'error' || type === 'success' || type === 'warning'),
        [`${k}-position-${position || 'topRight'}`]: true,
        [makeNotificationStyles(k)]: true,
    };
    
    const iconMap = {
        info:  `${k}-icon-information-fill`,
        warning: `${k}-icon-warning-fill`,
        success: `${k}-icon-success-fill`,
        error: `${k}-icon-error-fill`,
    };
    
    // type 优先级大于 icon，如果 type 存在且是四种类型之一，使用 type 对应的 icon
    // 否则如果 icon 有值，使用自定义 icon
    const hasIcon = (type && iconMap[type]) || icon;
    const iconName = type && iconMap[type] ? iconMap[type] : (typeof icon === 'string' ? icon : null);
    const iconColor = type ? theme.color[type === 'error' ? 'danger' : type] : 'default';
    
    return _$cv('div', {
        ...getRestProps(this),
        'className': _$cn(classNameObj),
        'ev-mouseenter': this.delayClose.onMouseEnter,
        'ev-mouseleave': this.delayClose.onMouseLeave,
        'ev-click': this.onClick
    }, (
        _$ce(2, 'div', [
            _$ce(2, 'div', [
                (hasIcon && iconName) ?
                    _$ce(2, 'div', (
                        _$cc(Icon, {
                            'className': _$cn(iconName),
                            'color': iconColor
                        })
                    ), 2, _$cn(`${k}-notification-icon`)) :
                    hasIcon && !iconName ?
                        _$ce(2, 'div', icon, 0, _$cn(`${k}-notification-icon`)) :
                        undefined,
                _$ce(2, 'div', [
                    (title) ?
                        _$ce(2, 'div', title, 0, _$cn(`${k}-notification-title`)) :
                        undefined,
                    (content || children) ?
                        _$ce(2, 'div', content || children, 0, _$cn(`${k}-notification-body`)) :
                        undefined
                ], 0, _$cn(`${k}-notification-content`))
            ], 0, _$cn({[`${k}-notification-wrapper`]: true, [`${k}-with-icon`]: hasIcon})),
            (closable) ?
                _$cc(Button, {
                    'type': 'none',
                    'icon': true,
                    'className': _$cn(`${k}-notification-close`),
                    'ev-click': this.onCloseClick,
                    'children': (
                        _$cc(Icon, {
                            'className': _$cn(`${k}-icon-close`),
                            'hoverable': true
                        })
                    )
                }) :
                undefined
        ], 0, _$cn(`${k}-notification-container`))
    ));
};